import { render } from "./Query.vue?vue&type=template&id=12eb50f8&scoped=true&ts=true"
import script from "./Query.vue?vue&type=script&lang=ts"
export * from "./Query.vue?vue&type=script&lang=ts"

import "./Query.vue?vue&type=style&index=0&id=12eb50f8&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12eb50f8"]])

export default __exports__